import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#2586AB",
        secondary: "#B6BDC3",
        accent: "#63C7E7"
      }
    }
  }
});
